import React from 'react';
import ChangeClinicsView from './ChangeClinicsView';
import MobileMenuRootView from './MobileMenuRootView';
import SnoozeNotificationsView from './SnoozeNotificationsView';
import { useMobileMenuProvider, MobileMenuViews } from './MobileMenuProvider';
import InvoicingPanel from 'shared/components/SidePanel/components/InvoicingPanel';
import { HStack } from '@televet/kibble-ui/build/chakra';

const MobileMenu = (): JSX.Element => {
  const { currentMobileMenuView } = useMobileMenuProvider();

  switch (currentMobileMenuView) {
    case MobileMenuViews.SendInvoice:
      return <InvoicingPanel isInMobileMenu={true} />;
    case MobileMenuViews.SnoozeNotifications:
      return <SnoozeNotificationsView />;
    case MobileMenuViews.ChangeClinics:
      return <ChangeClinicsView />;
    case MobileMenuViews.Root:
    default:
      return <MobileMenuRootView />;
  }
};

export default MobileMenu;

export const MenuTitle = ({ children }: { children: React.ReactNode }): JSX.Element => {
  return (
    <HStack h={10} mt={6}>
      {children}
    </HStack>
  );
};
